module.exports = __webpack_public_path__ + "img/题库.a68a5c58.png";